import axios from 'axios'
import { formatPrice } from '@js/utils/utils'
import clickOutside from './clickOutside'

const SharedPlugin = {
    install(Vue, options) {
        Vue.filter('formatPrice', formatPrice)
        Vue.prototype.$http = axios.create({
            baseURL: options?.axios?.baseURL,
            headers: {
                accept: options?.axios?.autoSuggestHeader
            },
            withCredentials: true
        })

        if (typeof window !== 'undefined') {
            Vue.prototype.$apteline = window[LIBRARY_NAME]
            Vue.directive('click-outside', clickOutside)
        }
    }
}

export default SharedPlugin
